import React, { Fragment, useState, useEffect } from 'react'



const ResponseReview = (props) => {


    return (
        <article style={{backgroundColor:'#EBFAEB',borderRadius:'10px'}} className='m-4'>

            <div className='writerName'>
                <h6 style={{fontWeight:'bold'}}>Del Valle Construction LLC</h6>
                <div className='dateUbicacion'>
                Lombard Ave, Everett, WA
                </div>
            </div>


            <div className='dateUbicacion'>
                <textarea className='textReview2'  disabled cols='30' rows='5' style={{fontSize:'15px'}} style={{fontSize:'15px'}}>
                    {props.response}
                </textarea>
            </div>


        </article>
    )

}


export default ResponseReview